import styled from 'styled-components';

export const StyledUpdateRates = styled.div`
    font-family: var(--bllink-font-primary);
    // height: 100%;

    .page-title {
        font-size: 26px;
        line-height: 30px;
    }

    .switch-btns-wrapper {
        display: flex;
        gap: 16px;
        margin: 38px 0 23px;
        
        .switch-btn {
            width: 210px;
            height: 38px;
            border: 1px solid rgba(110, 116, 255, 0.2);
            border-radius: 100px;
            font-size: 16px;
            line-height: 18px;
            position: relative;
            cursor: pointer;
            padding: 11px 20px;
            display: flex;
            align-items: center;
            gap: 12px;

            .radio-btn-outer {
                width: 16px;
                height: 16px;
                border: 1px solid rgba(110, 116, 255, 0.2);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: ${({ ltr }) => ltr ? '10px' : ''};
                left: ${({ ltr }) => ltr ? '' : '10px'};

                .radio-btn-inner {
                    width: 6.4px;
                    height: 6.4px;
                    background: rgba(110, 116, 255, 0.2);
                    border-radius: 50%;
                }
            }
        }

        .switch-btn.active {
            background-color: #E9E9FD;
            border: none;

            .radio-btn-outer {
                border: 1px solid #6A92FF;

                .radio-btn-inner {
                    background: linear-gradient(50.53deg, #6A92FF 20.83%, #8764FF 86.02%);
                }
            }
        }
    }

    .update-wrapper {
        border: 1px solid rgba(110, 116, 255, 0.4);
        border-radius: 28px;
        padding: 29px 24px;
        // height: calc(100% - 100px);

        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        
        input[type='number'],
        input[type="number"]:hover,
        input[type="number"]:focus {
            appearance: none;
            -moz-appearance: textfield;
        }

        // fixed rates
        .rates {
            .update-info {
                display: flex;
                gap: 13px;
                align-items: start;
                margin-bottom: 17px;
                max-width: 568px;
                color: rgba(55, 54, 71, 0.7);
            }

            .input-and-checkbox-wrapper {
                display: flex;
                align-items: center;
                gap: 28px;
                margin-bottom: 35px;

                .input-wrapper {
                    .input-label {
                        font-weight: 700;
                        font-size: 17px;
                        line-height: 23px;                        
                        color: rgba(55, 54, 71, 0.7);
                        margin-inline-start: 20px;
                    }

                    input {
                        width: 546px;
                        height: 37px;
                        font-size: 14px;
                        border: 1px solid rgba(110, 116, 255, 0.4);
                    }
                }
            }

            .checkbox {
                gap: 14px;
                margin-top: 35px;
                font-weight: 400 !important;
                line-height: 16px;
                color: rgba(55, 54, 71, 0.7);

                .checkbox-input {
                    width: 16px !important;
                    height: 16px !important;
                    border-color: #6F8BFF !important;
                    border-radius: 2px !important;
                }
            }

            .datepickers-container {
                display: flex;
                gap: 8px;
                margin-bottom: 17px;

                .input-item {
                    display: flex;
                    gap: 5px;
                    align-items: center;
                    font-weight: 700;
                    font-size: 17px;
                    line-height: 23px;
                    color: rgba(55, 54, 71, 0.7);
                    width: fit-content;

                    label {
                        margin: 0;
                        width: fit-content;
                    }
                }
            }

            // flexible rates
            .switch-manual-update {
                display: flex;
                gap: 40px;
                justify-content: center;
                margin-top: 18px;
                direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

                .switch-btn {
                    font-size: 16px;
                    line-height: 18px;
                    padding: 8px 15px;
                    color: rgba(55, 54, 71, 0.7);
                    cursor: pointer;
                }

                .switch-btn.selected {
                    background: #E9E9FD;
                    border-radius: 100px;
                    color: #373647;
                }
            }

            .manual-update {
                margin-right: 21px;
                margin-top: 19px;
                direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

                .title-row {
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 25px;
                    color: rgba(55, 54, 71, 0.7);
                    display: grid;
                    grid-template-columns: 1fr 2fr 2fr;
                    margin-bottom: 4px;
                    text-align: center;

                    .update-amount {
                        text-align: start;
                    }
                }

                .apt-cards-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-bottom: 20px;

                    .apt-card {
                        height: 52px;
                        background: rgba(255, 255, 255, 0.5);
                        border: 1px solid #A8C0FF;
                        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
                        border-radius: 11px;
                        display: grid;
                        grid-template-columns: 1fr 2fr 2fr;
                        padding: 9px 0;
                        font-size: 14px;
                        line-height: 25px;
                        color: rgba(55, 54, 71, 0.7);

                        .apt-card-text {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .input {
                            width: 185px;                          

                            label {
                                margin: 0;
                            }

                            .bllink-input-border {
                                height: 34px;
                                font-size: 14px;
                                line-height: 22px;
                            }
                        }
                    }
                }
            }

            .ScrollbarsCustom {
                position: relative;

                .excel-example {
                    position: absolute;
                    top: 25px;
                    font-size: 16px;
                    line-height: 23px;
                    color: rgba(55, 54, 71, 0.7);
                    display: flex;
                    gap: 15px;
                    right: ${({ ltr }) => ltr ? '' : '0'};

                    img {
                        cursor: pointer;
                    }
                }
            }

            .upload-files {
                margin-top: 53px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .drag-and-drop-field {
                    display: flex;
                    flex-direction: column;
                    gap: 19px;
                    align-items: center;
                    cursor: pointer;

                    img {
                        height: 70px;
                    }

                    .field-title {
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 24px;
                        color: rgba(55, 54, 71, 0.7);
                        max-width: 232px;
                        text-align: center;
                    }
                }

                .files-list {
                    margin-top: 40px;

                    .list-item {
                        gap: 17px;

                        .progress-line {
                            .progress-head {
                                gap: 120px;
                                white-space: nowrap;

                                .file-name {
                                    color: rgba(55, 54, 71, 0.7);
                                }
                            }
                        }
                    }
                }
            }

            .datepickers-and-checkbox-wrapper {
                padding: 21px 24px 11px;
                border-top: 1px solid rgba(110, 116, 255, 0.4);
                margin: 0 -24px;

                .datepickers-container {
                    gap: 17px;
                    margin-bottom: 35px;

                    .input-item {
                        display: flex;
                        flex-direction: column;
                        gap: 7px;
                        align-items: start;
                    }
                }

                .checkbox-and-btn {
                    display: flex;
                    justify-content: space-between;
                    align-items: start;

                    .checkbox {
                        margin-top: 0;
                    }
                }
            }
        }

        .btn-wrapper {
            display: flex;
            justify-content: flex-end;

            .app-btn {
                width: 206px;
                height: 44px;
            }
        }
    }
`
